import { render, staticRenderFns } from "./taxpayers-unactivated-icon.vue?vue&type=template&id=3f8cf959"
import script from "./taxpayers-unactivated-icon.vue?vue&type=script&lang=js"
export * from "./taxpayers-unactivated-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports